// Template Generated by DataExtraction.py at 1717541024
        
import CESGEnglishD2 from "../../Forms/CESG/CESG_EnglishD2.png";
import CESGEnglishD2Labels from "../../Labels/CESG/CESG_EnglishD2.json";
import CESGFrenchD2 from "../../Forms/CESG/CESG_FrenchD2.png";
import CESGFrenchD2Labels from "../../Labels/CESG/CESG_FrenchD2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import app from "../../../App";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchD2Labels : CESGEnglishD2Labels;
    const formImage = isFrench ? CESGFrenchD2 : CESGEnglishD2;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const now = moment().format("yyyy/MM/DD");

    const application = data.application;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const subscriber2Include = data.common.subscriber2Include;

    let cpName = "";
    const isEitherSubscriberCustodialParent = (subscriber.custodialParent) || (subscriber2Include && jointSubscriber.custodialParent);

    if (!isEitherSubscriberCustodialParent){
        cpName = application.custodialParentFirstName + " " + application.custodialParentLastName
    }

    // Drawing the form
    drawText(cpName, "cpName");
    drawText(now, "cpSignatureDate");
    drawText(now, "s1SignatureDate");
    drawText(now, "s2SignatureDate");
    drawText(application.bcResidentTypeOfID, "typeOfID");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchD2Labels : CESGEnglishD2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber2Include = state.common.subscriber2Include;
    
    // S1 Signature View
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("S1 Signature View", labels))],
    });
    

    if (subscriber2Include) {
        // S2 Signature View
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("S2 Signature View", labels))],
        });
    }
    
    // TODO need to figure out custodial parent signature
    // // CP Signature View
    // signers.push({
    //     [unknownSignerFIXME]: [signatureTab(unknownSignerFIXME, documentId, pageNumber, signatureLabel("CP Signature View", labels))], // TODO MUST check if signer is correct!
    // });
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    